module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h3', [_vm._v("Got jokes?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.initJokes
    }
  }, [_vm._v("Add 10 Jokes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addJoke
    }
  }, [_vm._v("Add a Joke")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.types), function(type) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedTypes),
        expression: "checkedTypes"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": type,
        "checked": Array.isArray(_vm.checkedTypes) ? _vm._i(_vm.checkedTypes, type) > -1 : (_vm.checkedTypes)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.checkedTypes,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = type,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedTypes = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.checkedTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedTypes = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(type))]), _vm._v(" \n  ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.$store.state.jokes), function(joke, index) {
    return _c('Joke', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkedTypes.includes(joke.type)),
        expression: "checkedTypes.includes(joke.type)"
      }],
      key: "index",
      attrs: {
        "joke": joke,
        "index": index
      }
    })
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c80bdd2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 12
// module chunks = 0